import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { ActionSheetController, MenuController } from '@ionic/angular';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  public foto: any;

  constructor(private menu:MenuController,private actionSheetController:ActionSheetController) { 
  }
 notificador
 notiData

  ngOnInit() {}

  openMenu(){
    this.menu.toggle()

  }
 traerNotificacionesPuntosSemilla(){

 }

}
